<template>
  <div class="password-input-container">
    <input
      :type="showPassword ? 'text' : 'password'"
      class="w-100 border-0 input"
      :placeholder="placeholder"
      id="password"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :tabindex="tabindex"
      required
    />

    <font-awesome-icon
      @click="toggleShowPassword"
      :icon="showPassword ? 'eye-slash' : 'eye'"
      size="1x"
      class="password-eye mx-2"
    />
  </div>
</template>

<script>
export default {
  name: "PasswordInput",
  props: ["value", "tabindex", "placeholder"],
  data() {
    return {
      showPassword: false
    };
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  padding: 0.375rem 0.75rem;
  height: 100%;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordInput.vue